'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { getGa4PageViewContext, trackGa4PageView } from './ga4';

export function Ga4PageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();
  const lastTrackedPathname = useRef<string>();

  useEffect(() => {
    if (!pathname || lastTrackedPathname.current === pathname) return;
    lastTrackedPathname.current = pathname;
    trackGa4PageView(getGa4PageViewContext(pathname, search));
  }, [pathname, search]);

  return null;
}
